import { render, staticRenderFns } from "./bigDataCharts2.vue?vue&type=template&id=da2ed5e8&"
import script from "./bigDataCharts2.vue?vue&type=script&lang=js&"
export * from "./bigDataCharts2.vue?vue&type=script&lang=js&"
import style0 from "./bigDataCharts2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports